import React, { useState, useEffect, Fragment } from 'react';
import services from '../../services';
import MessageModal from '../../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';
import FormHelperText from '@material-ui/core/FormHelperText';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { TableContent } from '../../../Common/Table/tableContent';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import { useHistory } from 'react-router';
import { AddSupplierAddEditSchemaObject } from '../../AddSupplierSchema';
import Joi, { date } from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PurchaseAdviceAddEditObject, OrderItemAddEditObject, OrderItemAddEditObjectForUnit } from '../../purchaseAdvice';
import { generateStatus } from '../../satusGenerator';
import BackupIcon from '@material-ui/icons/Backup';
import VisibilityIcon from '@material-ui/icons/Visibility';


const screenCode = 'PURCHASEORDER';

export function OrderCompletion(props) {

    let history = useHistory();
    const [orderDetails, setOrderDetails] = useState([]);
    const [itemDetails, setItemDetails] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [supplierItemsDetils, setSupplierItemsDetils] = useState([]);
    const [isOrderConfirmed, setIsOrderConfirmed] = useState(true);
    const contentRowNames = ["tagNo", "grossAmount", "netAmount", "deductionAmount", "actualAmount"];
    const [orderCompletion, setOrderCompletion] = useState({
        groupID: '0',
        operationEntityID: '0',
        orderID: '0',
        collectionTypeID: '0',
        customerID: '0',
        rejectReason: ''
    });
    const [purchaseOrderItem, setPurchaseOrderItem] = useState({
        collectionTypeID: '0',
        measuringUnit: '0',
        price: '',
        packageWeight: '',
        totalPackagesStore: '',
        totalPackagesExport: '',
        itemQuantity: '',
        maxAmount: '',
        aspNetUserId: '0'
    });
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [orderItemErrors, setOrderItemErrors] = useState({});
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openRejectDialog, setOpenRejectDialog] = React.useState(false);
    const [filterSupplier, setFilterSupplier] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [supplierItems, setSupplierItems] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState({});
    const [remainQty, setRemainQty] = useState(0);
    const [users, setUsers] = useState([]);

    const schema = Joi.object(AddSupplierAddEditSchemaObject).options({ allowUnknown: true });
    const orderItemsschema = Joi.object(OrderItemAddEditObject).options({ allowUnknown: true });
    const orderItemsschemaForUnit = Joi.object(OrderItemAddEditObjectForUnit).options({ allowUnknown: true });

    const encriptedText = props.match.params["id"];
    const id = (encriptedText !== undefined) ? CommonDecryptParam(encriptedText) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        if (messageModel.hidden === false) {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])

    useEffect(() => {
        if (parseFloat(purchaseOrderItem.totalPackagesStore) >= parseFloat(purchaseOrderItem.totalPackagesExport)
            && parseFloat(purchaseOrderItem.totalPackagesStore) !== 0 && parseFloat(purchaseOrderItem.totalPackagesExport) !== 0) {
            setOrderItemErrors({
                ...orderItemErrors,
                orderItem: "Max Total Packages value is less than total package"
            });
        } else {
            const error = { ...orderItemErrors }
            delete error["orderItem"]
            setOrderItemErrors(error);
        }
    }, [purchaseOrderItem])

    useEffect(() => {
        setPurchaseOrderItem({
            ...purchaseOrderItem,
            itemQuantity: '',
            maxAmount: '',
            packageWeight: '',
            totalPackagesStore: '',
            totalPackagesExport: ''
        })
    }, [purchaseOrderItem.measuringUnit]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDORDERCOMPLETION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setScreenData();
        }
    }

    async function setScreenData() {
        var result = await services.getOrderDetailsForOrderCompletionScreen(id);
        setOrderDetails(result.order);

        getItems(result.order.operationEntityID);
        getUsers(result.order);

        var items = [];

        result.orderItems.forEach(x => {
            var supplierItems = [];

            result.supplierOrderItems.forEach(r => {
                if (r.orderItemID === x.orderItemID) {
                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.suppliedQauntity * parseFloat(r.unitPrice),
                        supplingQauntity: r.supplingQauntity,
                        statusTypeID: r.statusTypeID,
                        remark: r.remark,
                        suppliedQauntity: r.suppliedQauntity
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.state,
                    x.remQty,
                    supplierItems
                )
            );

        });

        setItemDetails(items);

        setOrderCompletion({
            ...orderCompletion,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            orderID: result.order.orderID
        });
    }

    async function getItems(id) {
        const items = await services.GetCollectionTypeByOperationEntityForSearchDropDown(id);
        setCollectionTypes(items);
    }

    async function getUsers(data) {
        const userRes = await services.getUsers(data);
        setUsers(userRes);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setOrderCompletion({
            ...orderCompletion,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntity,
            orderNumber: '',
            buyerID: '0',
            invoiceDate: new Date().toISOString().split('T')[0],
            dueDate: new Date().toISOString().split('T')[0],
            collectionTypeID: '0',
            itemQuantity: '',
            measuringUnit: ''
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function onConfirmClick(e) {
        e.preventDefault();

        setIsClicked(true);

        const response = await services.saveOrderCompletionStatus(orderCompletion,orderDetails.orderNumber);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);

        setIsClicked(false);
    }

    async function handleRejectOkClick() {
        if (orderCompletion.rejectReason.trim().length === 0) {
            setErrors({
                ...errors,
                rejectReason: "Please enter reject reason."
            });
            return;
        } else {
            setOpenRejectDialog(false);

            const response = await services.saveOrderCompletionStatus(orderCompletion);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
    }

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, state, remQty, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            state,
            remQty,
            supplierItems
        };
    }

    function handleClickOpen() {
        setOpenDialog(true);
    };

    const handleRejectClose = () => {
        clearErrorMessage();
        clearRejectMessage();
        setOpenRejectDialog(false)
    }

    function clearErrorMessage() {
        const error = { ...errors }
        delete error["rejectReason"]
        setErrors(error);
    }

    function clearRejectMessage() {
        setOrderCompletion({
            ...orderCompletion,
            rejectReason: ''
        });
    }

    function handleChange(target) {
        setOrderCompletion({
            ...orderCompletion,
            rejectReason: target.value
        });
    }

    function roundNumber(num) {
        return (Math.round(num * 100) / 100).toFixed(2);
    }

    function totalCal(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID) {
                tot = tot + parseFloat(s.totalPrice);
            }
        });

        return (
            <div>{roundNumber(parseFloat(tot))}</div>
        )
    }

    async function viewSupplierItemDetails(rowData, itemData) {
        history.push({
            pathname: 'viewWieghment/' + CommonEncryptParam(itemData.supplierOrderItemsID.toString()),
            data: id
        })
    }

    async function UploadManuelSupplierItemDetails(rowData, itemData) {
        var res = await services.uploadManualCompletion(itemData.supplierOrderItemsID);
        setMessageModel({ ...messageModel, hidden: false, type: res.statusCode, disciption: res.message });
    }

    async function handleAddItem() {
        if (orderItemErrors.orderItem) {
            return;
        }

        handleClose();

        const response = await services.saveOrderitem(purchaseOrderItem, orderDetails);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        if (response.statusCode === "Success") {
            setScreenData();
        }
    }

    const handleClose = () => {
        setDailogBoxEmpty();
        setOpenDialog(false);
    };

    function setDailogBoxEmpty() {
        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: '0',
            measuringUnit: '0',
            price: '',
            packageWeight: '',
            totalPackagesStore: '',
            totalPackagesExport: '',
            itemQuantity: '',
            maxAmount: '',
            aspNetUserId: '0'
        });
        const error = { ...errors }
        delete error["supplierItemErrMsg"]
        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null)
            return;

        var nameV = "collectionTypeID";
        var valueV = data["collectionTypeID"];

        const error = { ...orderItemErrors }
        var errorMessage = "";
        errorMessage = validateProperty({ name: nameV, value: valueV }, OrderItemAddEditObject)

        errorMessage ? error[nameV] = errorMessage : delete error[nameV];

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: valueV.toString()
        });

        setOrderItemErrors(error);
    }

    function handlePurchaseItemChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...orderItemErrors }
        var errorMessage = "";
        errorMessage = validateProperty(target, OrderItemAddEditObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            [e.target.name]: value
        })
        setOrderItemErrors(error);
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.collectionTypeName}
                    </TableCell>
                    <TableCell align="right">{row.itemQuantity}</TableCell>
                    <TableCell align="right">{row.remQty === null ? 0 : row.remQty}</TableCell>
                    <TableCell align="right">{totalCal(row)}</TableCell>
                    <TableCell align="right" component="th" scope="row">
                        {row.measuringUnit === 1 ? "Kg" : "Unit"}
                    </TableCell>
                    <TableCell align="right">{generateStatus(row.state)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={7}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.supplierItems.length !== 0 ? <Box marginLeft={20}>
                                <Typography variant="body2" gutterBottom component="div">
                                    Supplier Details
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Weighment Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Remark</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Action</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.supplierItems.map((itemData, i) => {
                                            return (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row">
                                                        {itemData.supplierName}
                                                    </TableCell>
                                                    <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.suppliedQauntity)}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                    <TableCell align="right">{itemData.remark ? itemData.remark : "-"}</TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            generateStatus(itemData.statusTypeID)
                                                        }
                                                    </TableCell>
                                                    <TableCell align="right">

                                                        <IconButton onClick={() => viewSupplierItemDetails(row, itemData)} color="primary" aria-label="upload picture" component="span">
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box> : <p style={{ fontSize: "14px" }}>No Data.</p>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Add Order Completion"
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form onSubmit={(e) => onConfirmClick(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-8">
                                        <div className="row pt-2">
                                            <div className="col"><p style={{ fontSize: "14px" }}>
                                                <b>Order Number: </b> {orderDetails.orderNumber}</p>
                                            </div>
                                            <div className="col"><p style={{ fontSize: "14px", textAlign: "center" }}>
                                                <b>Date: </b>{new Date().toISOString().split('T')[0]}</p>
                                            </div>
                                            <div><p style={{ fontSize: "14px", float: "right" }}>
                                                <b>Buyer: </b>{orderDetails.buyerName}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex flex-row-reverse">
                                        <button
                                            className="btn btn-warning"
                                            type="button"
                                            onClick={handleClickOpen}>
                                            Add Order Item
                                        </button>
                                    </div>
                                </div>
                                <Dialog open={openDialog} onClose={handleClose} maxWidth="md" fullWidth={true}
                                    aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title">Add Order Items</DialogTitle>
                                    <DialogContent>
                                        <div>
                                            <div className="form-group row">
                                                <div className="col-md-6 pt-4">
                                                    <Autocomplete
                                                        id="collectionTypeID"
                                                        options={collectionTypes}
                                                        getOptionLabel={(option) => option.collectionTypeName.toString()}
                                                        onChange={(e, value) => handleSearchDropdownChange(value)}
                                                        renderInput={(params) => <TextField {...params} label="Product *" variant="outlined" size="small" />}
                                                    />
                                                    {orderItemErrors["collectionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["collectionTypeID"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md-6">
                                                    <InputLabel shrink id="aspNetUserId">Purchasing Manager *</InputLabel>
                                                    <Select fullWidth
                                                        id="aspNetUserId"
                                                        name="aspNetUserId"
                                                        value={purchaseOrderItem.aspNetUserId}
                                                        onChange={(e) => handlePurchaseItemChange(e)}>
                                                        <MenuItem value="0">--Select Purchasing Manager--</MenuItem>
                                                        {generateDropDownMenu(users)}
                                                    </Select>
                                                    {orderItemErrors["aspNetUserId"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["aspNetUserId"]}</FormHelperText>}
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-6 pt-2">
                                                    <TextField fullWidth label="Price *"
                                                        name="price"
                                                        id="price"
                                                        value={purchaseOrderItem.price}
                                                        type="text"
                                                        onChange={(e) => handlePurchaseItemChange(e)}
                                                    />
                                                    {orderItemErrors["price"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["price"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md-6">
                                                    <InputLabel shrink id="measuringUnit">Measuring Unit *</InputLabel>
                                                    <Select fullWidth
                                                        id="measuringUnit"
                                                        name="measuringUnit"
                                                        value={purchaseOrderItem.measuringUnit}
                                                        onChange={(e) => handlePurchaseItemChange(e)}>
                                                        <MenuItem value="0">--Select Measuring Unit--</MenuItem>
                                                        <MenuItem value="1">Kg</MenuItem>
                                                        <MenuItem value="2">Unit</MenuItem>
                                                    </Select>
                                                    {orderItemErrors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["measuringUnit"]}</FormHelperText>}
                                                </div>
                                            </div>
                                            {purchaseOrderItem.measuringUnit === "1" ?
                                                <div>
                                                    <div className="form-group row">
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Package Weight *"
                                                                name="packageWeight"
                                                                id="packageWeight"
                                                                value={purchaseOrderItem.packageWeight}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Total Packages (Store) *"
                                                                name="totalPackagesStore"
                                                                id="totalPackagesStore"
                                                                value={purchaseOrderItem.totalPackagesStore}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Max Total Packages (Export) *"
                                                                name="totalPackagesExport"
                                                                id="totalPackagesExport"
                                                                value={purchaseOrderItem.totalPackagesExport}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-md pt-4">
                                                            <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore}</div>
                                                        </div>
                                                        <div className="col-md pt-4">
                                                            <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                (purchaseOrderItem.measuringUnit === "2" ?
                                                    <div>
                                                        <div className="form-group row">
                                                            <div className="col-md pt-1">
                                                                <TextField fullWidth label="Package Weight *"
                                                                    name="packageWeight"
                                                                    id="packageWeight"
                                                                    value={purchaseOrderItem.packageWeight}
                                                                    type="text"
                                                                    onChange={(e) => handlePurchaseItemChange(e)}
                                                                />
                                                                {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                            </div>
                                                            <div className="col-md pt-1">
                                                                <TextField fullWidth label="Total Packages (Store) *"
                                                                    name="totalPackagesStore"
                                                                    id="totalPackagesStore"
                                                                    value={purchaseOrderItem.totalPackagesStore}
                                                                    type="text"
                                                                    onChange={(e) => handlePurchaseItemChange(e)}
                                                                />
                                                                {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                            </div>
                                                            <div className="col-md pt-1">
                                                                <TextField fullWidth label="Max Total Packages (Export) *"
                                                                    name="totalPackagesExport"
                                                                    id="totalPackagesExport"
                                                                    value={purchaseOrderItem.totalPackagesExport}
                                                                    type="text"
                                                                    onChange={(e) => handlePurchaseItemChange(e)}
                                                                />
                                                                {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col-md pt-4">
                                                                <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore}</div>
                                                            </div>
                                                            <div className="col-md pt-4">
                                                                <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport}</div>
                                                            </div>
                                                        </div>
                                                    </div> : null)
                                            }
                                            <div>
                                                {orderItemErrors["orderItem"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["orderItem"]}</FormHelperText>}
                                            </div>
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={() => trackPromise(handleAddItem())}
                                            color="primary"
                                            disabled={(purchaseOrderItem.measuringUnit === "0" ? true :
                                                (validate(orderItemsschema, purchaseOrderItem)))}
                                        >
                                            Add
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={openRejectDialog} onClose={handleRejectClose}
                                    aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title">Reject Reason</DialogTitle>
                                    <DialogContent>
                                        <TextareaAutosize
                                            fullwidth
                                            id="rejectReason"
                                            rowsMin={5}
                                            onChange={(e) => handleChange(e.target)}
                                            value={orderCompletion.rejectReason}
                                        />
                                        {errors["rejectReason"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["rejectReason"]}</FormHelperText>}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleRejectClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleRejectOkClick} color="primary">
                                            Confirm
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <div className="row">
                                    <div className="col">
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table">
                                                <TableHead style={{ backgroundColor: "White" }}>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Remaining Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Total Price (LKR.)</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {itemDetails.map((row, i) => {
                                                        return (
                                                            <Row key={i} row={row} />
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    disabled={isClicked}
                                    type="submit"
                                    className="btn btn-primary pull-right"
                                    value="Approve"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}
